import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import {
  AppState,
  CoreCountersActions,
  CoreCounterState,
} from '@osos/shared/legacy-core';
import { CounterWidgetDataEntryPresenterModel } from '@osos/shared/types';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-counter-widget-list',
  templateUrl: './counter-widget-list.component.html',
  styleUrls: ['./counter-widget-list.component.scss'],
  standalone: false,
})
export class CounterWidgetListComponent implements OnInit {
  @Input() isMobileScreen: boolean;
  counters$: Observable<CounterWidgetDataEntryPresenterModel[]>;
  trackByFn = (index: number): number => index;
  constructor(private store: Store) {}

  ngOnInit() {
    this.counters$ = this.store.select(CoreCounterState.presentedCounters);
    if (!this.store.selectSnapshot(AppState.headlessModeEnabled)) {
      this.store.dispatch(new CoreCountersActions.FetchCountersEndUser());
    }
  }
}
